import { gsap, ScrollTrigger, SplitText } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger, SplitText)

export function impactSavings(element: Element, duration: number, ease: string): void {
  const savings = [...Array.from(element.querySelectorAll('.js-impact'))] as HTMLElement[]
  const titles = [...Array.from(element.querySelectorAll('.js-title'))] as HTMLElement[]
  const units = [...Array.from(element.querySelectorAll('.js-unit'))] as HTMLElement[]

  const titleLines: any[] = []
  const unitLines: any[] = []

  let mm = gsap.matchMedia(),
    breakPoint = 768

  mm.add(
    {
      // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
      isDesktop: `(min-width: ${breakPoint}px)`,
      isMobile: `(max-width: ${breakPoint - 1}px)`,
      reduceMotion: '(prefers-reduced-motion: reduce)'
    },
    context => {
      // Add type guard to ensure context.conditions is not undefined
      if (!context.conditions) {
        return
      }

      // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
      let { isDesktop, isMobile, reduceMotion } = context.conditions

      // split titles

      titles.forEach(title => {
        let newtitle = new SplitText(title, {
          type: 'lines',
          linesClass: 'lineChild'
        })
        let innerSubtitle = new SplitText(title, {
          type: 'lines',
          linesClass: 'lineParent'
        })
        gsap.set(newtitle.lines, { yPercent: 100 })

        titleLines.push(newtitle.lines)
      })

      units.forEach(unit => {
        let newunit = new SplitText(unit, {
          type: 'lines',
          linesClass: 'lineChild'
        })
        let innerSubunit = new SplitText(unit, {
          type: 'lines',
          linesClass: 'lineParent'
        })
        gsap.set(newunit.lines, { yPercent: 100 })

        unitLines.push(newunit.lines)
      })

      const savingTl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: 'center bottom',
          // end: 'center center',
          // scrub: 1,
          //markers: true,
          invalidateOnRefresh: true
        }
      })

      savingTl
        .fromTo(
          savings,
          { width: '30%' },
          {
            width: i => {
              let amount
              isMobile ? (amount = 100 - i * 10 + '%') : (amount = 100 - i * 15 + '%')
              return amount
            },
            duration: 1.2,
            stagger: 0.2,
            ease: 'expo.out'
          },
          0
        )
        .to(titleLines, { duration: 1.25, yPercent: 0, ease: 'expo.out', delay: 0.5 }, 0)
        .to(unitLines, { duration: 1.25, yPercent: 0, ease: 'expo.out', delay: 0.5 }, 0)

      return () => {
        // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
        // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
      }
    }
  )
}
